export default "__VITE_ASSET__BKGahHGW__"